import { Route } from "react-router-dom";

import { ForgotPassword } from "src/pages/master/ForgotPassword";
import { AUTH_ROUTES } from "src/pages/auth/constants";

import { LoginScreen } from "./Login";

/**
 * Route tree for the auth module: sign-in and password recovery, mounted at the app root.
 * Kept eager (not lazy-loaded) since these are the first screens shown before the app shell renders.
 */
export const authRoutes = (
  <>
    <Route path={AUTH_ROUTES.root} element={<LoginScreen />} />
    <Route path={AUTH_ROUTES.login} element={<LoginScreen />} />
    <Route path={AUTH_ROUTES.forgotPassword} element={<ForgotPassword />} />
  </>
);
